import { belongsTo } from "@ember-data/model";
import JournalEvent from "parog-web/models/journal-event";
import dayjs from "dayjs";
import type CnamProcessStartedJournalEvent from "./cnam-process-started-journal-event";
import type IntlService from "ember-intl/services/intl";
import {
  validateDate,
  validatePresence
} from "ember-changeset-validations/validators";
import tWithDefault from "parog-web/utils/t-with-default";
import type Patient from "./patient";

//---- Automatically generated, don't update this part ----

/**
 * This JE is created everytime we successfully retrieved a DMP for a patient.
 */
export default class DmpRetrievalSuccessfulJournalEvent extends JournalEvent {
  static override type = "dmp-retrieval-successful-journal-event";

  @belongsTo("cnam-process-started-journal-event", {
    async: false,
    inverse: "dmpRetrievalSuccessfulJournalEvent"
  })
  declare cnamProcessStartedJournalEvent: CnamProcessStartedJournalEvent;

  static override validations(intl: IntlService) {
    return {
      occurredAt: [
        validatePresence({
          presence: true,
          description: tWithDefault(
            intl,
            "validations.dmp-retrieval-successful-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
          onOrBefore: dayjs().endOf("day").toDate()
        })
      ]
    };
  }

  //---- End of generated code ----

  @belongsTo("patient", {
    async: false,
    inverse: "dmpRetrievalSuccessfulJournalEvent"
  })
  declare patient: Patient;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "dmp-retrieval-successful-journal-event": DmpRetrievalSuccessfulJournalEvent;
  }
}
